import { ApiService } from '~/service/service.api';
import { NoteImportDto } from '~/shared/dto/admin/note.dto';
import { NoteId } from '~/shared/dto/id';
import { Model } from '~/shared/service/service.base';
import { ImportModel } from './model.import';

type NoteRowType = Omit<InstanceType<typeof NoteImportDto>, 'id'> & {
	noteId: NoteId;
};

@Model()
export class NoteImportModel extends ImportModel<NoteImportDto> {
	constructor(api: ApiService) {
		super(NoteImportDto, api.noteImport.bind(api));
	}

	getItemFromRow(row: NoteRowType): NoteImportDto {
		return {
			id: this.parseNumber(row.noteId) as NoteId,
			name: row.name,
			synonyms: this.parseStringArray(row.synonyms),
			active: this.parseBoolean(row.active),
		};
	}

	downloadTemplate = () => {
		const example: NoteRowType = {
			noteId: 44,
			name: 'Example Note',
			synonyms: ['Example', 'Sample'],
			active: true,
		};

		this.buildAndDownloadCSV('note-import-template.csv', example);
	};
}
